import api from './api';

export async function getRecipeByMenuProduct(menuProductId) {
  const { data } = await api.get(`/menu-product-portion/menu-product/${menuProductId}`);
  return data;
}

export async function createMenuProductPortion(payload) {
  const { data } = await api.post('/menu-product-portion', payload);
  return data;
}

export async function updateMenuProductPortion(id, payload) {
  const { data } = await api.put(`/menu-product-portion/${id}`, payload);
  return data;
}

export async function deleteMenuProductPortion(id) {
  const { data } = await api.delete(`/menu-product-portion/${id}`);
  return data;
}
